<template>
    <!-- <svg :x="box.x" :y="box.y" :width="box.width" :height="box.height">
        <rect :x="0" :y="0" :width="box.width" :height="box.height" fill="transparent" stroke="grey" stroke-width="0.5"></rect>
        <text :x="(0 + box.width)/2" :y="(0 + box.height)/2" text-anchor="middle" contenteditable>Hello</text>
    </svg> -->
    <div
        v-if="text != null && text !== ''"
        class="title text-field center d-flex align-center"
        :style="formattedStyle"
    >
        <span style="width: 100%">{{ text }}</span>
    </div>
</template>
<script lang="ts">
import { Box } from "./models";
import { toNative, Vue, Component } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class TitleComponent extends Vue {
    // @Prop() titleStyle: any
    @Prop() text: string;
    @Prop() box: Box;

    // @Watch("titleStyle")
    // watch_titleStyle() {
    //     console.log("titleStyle", this.titleStyle)
    // }

    // get text() {
    //     return this.box.properties?.title?.trim()
    // }

    get generalTheme() {
        return this.box?.selectedGeneralTheme;
    }

    get boxTitleStyle() {
        // console.log("this.generalTheme?.values?.boxTitleStyle", this.generalTheme?.values?.boxTitleStyle)
        return this.box.boxTitleStyle; //this.generalTheme?.values?.boxTitleStyle
    }

    get formattedStyle(): { [key: string]: any } {
        return {
            background: this.boxTitleStyle?.fill,
            borderColor: this.boxTitleStyle?.border ? this.boxTitleStyle.stroke : null,
            borderWidth: this.boxTitleStyle?.border ? "1px" : 0,
            borderRadius: this.boxTitleStyle.borderRadius
                ? this.boxTitleStyle.borderRadius + "px"
                : null,
            fontWeight: this.boxTitleStyle?.bold ? "bold" : null,
            boxSizing: "border-box",
            borderCollapse: "collapse",
            color: this.boxTitleStyle?.color,
        };
    }
}

export default toNative(TitleComponent);
</script>
<style lang="css" scoped>
.text-field {
    height: 100%;
    width: 100%;
}

:is(.text-field, td, th, tr):is(.center, .middle, .text-center, .text-middle) {
    text-align: center;
}

:is(.text-field, td, th, tr):is(.start, .text-start) {
    text-align: start;
}

:is(.text-field, td, th, tr):is(.end, .text-end) {
    text-align: end;
}

.title {
    border: 1px solid;
    overflow-x: hidden;
    text-wrap: wrap;
}
</style>
